import BasicModal from '../../../../components/action-modal';
import makeToast from '../../../../components/toaster';
import { DeleteEmbeddedModal } from '../embedded.props';
import { deleteEmbeddedModel } from '../services/embedded-llm';

function DeleteEmbeddedLLM({
  open,
  dataToDelete,
  setDataToDelete,
  setDeleteLLMModalOpen,
  setDataUpdated,
}: DeleteEmbeddedModal) {
  const handleCancelClick = () => {
    setDeleteLLMModalOpen(false);
  };

  const handleDeleteLLM = () => {
    deleteEmbeddedModel(dataToDelete)
      .then((res) => {
        if (res.status === 200) {
          setDataUpdated((prev) => !prev);
          handleCancelClick();
          makeToast('success', 'Embedding has been deleted!');
          setDataToDelete([]);
        } else if (res.status === 401) {
          // Handle logout if needed
        }
      })
      .catch((err) => {
        setDeleteLLMModalOpen(false);
        makeToast(
          'error',
          err?.response?.data?.message
            ? `${err?.response?.data?.message}.`
            : 'Something went wrong!',
        );
        setDataToDelete([]);
      });
  };

  return (
    <BasicModal
      className="w-[400px]"
      open={open}
      resetData={handleCancelClick}
      confirmButtonText="Delete"
      saveData={handleDeleteLLM}
    >
      <span className="font-semibold text-center pb-3">
        {`Are you sure you want to delete selected ${dataToDelete?.length === 1 ? ' embedding?' : 'embeddings?'}`}
      </span>
    </BasicModal>
  );
}

export default DeleteEmbeddedLLM;
